 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TOCATCHATHIEF_COV from '@/components/tocatchathief_cov'
 import TOCATCHATHIEF_REW from '@/components/tocatchathief_rew'
 import TOCATCHATHIEF_ADP from '@/components/tocatchathief_adp'
 import TOCATCHATHIEF_TIT from '@/components/tocatchathief_tit'
 import TOCATCHATHIEF_FRM01 from '@/components/tocatchathief_frm01'
 import TOCATCHATHIEF_ACK from '@/components/tocatchathief_ack'
 import TOCATCHATHIEF_HTL from '@/components/tocatchathief_htl'
 import TOCATCHATHIEF_CONTENTS from '@/components/tocatchathief_contents'
 import TOCATCHATHIEF_PRO from '@/components/tocatchathief_pro'
 import TOCATCHATHIEF_CH01 from '@/components/tocatchathief_ch01'
 import TOCATCHATHIEF_CH02 from '@/components/tocatchathief_ch02'
 import TOCATCHATHIEF_CH03 from '@/components/tocatchathief_ch03'
 import TOCATCHATHIEF_CH04 from '@/components/tocatchathief_ch04'
 import TOCATCHATHIEF_CH05 from '@/components/tocatchathief_ch05'
 import TOCATCHATHIEF_CH06 from '@/components/tocatchathief_ch06'
 import TOCATCHATHIEF_CH07 from '@/components/tocatchathief_ch07'
 import TOCATCHATHIEF_CH08 from '@/components/tocatchathief_ch08'
 import TOCATCHATHIEF_CH09 from '@/components/tocatchathief_ch09'
 import TOCATCHATHIEF_CH10 from '@/components/tocatchathief_ch10'
 import TOCATCHATHIEF_CH11 from '@/components/tocatchathief_ch11'
 import TOCATCHATHIEF_CH12 from '@/components/tocatchathief_ch12'
 import TOCATCHATHIEF_CH13 from '@/components/tocatchathief_ch13'
 import TOCATCHATHIEF_CH14 from '@/components/tocatchathief_ch14'
 import TOCATCHATHIEF_CH15 from '@/components/tocatchathief_ch15'
 import TOCATCHATHIEF_CH16 from '@/components/tocatchathief_ch16'
 import TOCATCHATHIEF_CH17 from '@/components/tocatchathief_ch17'
 import TOCATCHATHIEF_CH18 from '@/components/tocatchathief_ch18'
 import TOCATCHATHIEF_CH19 from '@/components/tocatchathief_ch19'
 import TOCATCHATHIEF_CH20 from '@/components/tocatchathief_ch20'
 import TOCATCHATHIEF_CH21 from '@/components/tocatchathief_ch21'
 import TOCATCHATHIEF_CH22 from '@/components/tocatchathief_ch22'
 import TOCATCHATHIEF_CH23 from '@/components/tocatchathief_ch23'
 import TOCATCHATHIEF_CH24 from '@/components/tocatchathief_ch24'
 import TOCATCHATHIEF_CH25 from '@/components/tocatchathief_ch25'
 import TOCATCHATHIEF_CH26 from '@/components/tocatchathief_ch26'
 import TOCATCHATHIEF_CH27 from '@/components/tocatchathief_ch27'
 import TOCATCHATHIEF_CH28 from '@/components/tocatchathief_ch28'
 import TOCATCHATHIEF_CH29 from '@/components/tocatchathief_ch29'
 import TOCATCHATHIEF_CH30 from '@/components/tocatchathief_ch30'
 import TOCATCHATHIEF_CH31 from '@/components/tocatchathief_ch31'
 import TOCATCHATHIEF_CH32 from '@/components/tocatchathief_ch32'
 import TOCATCHATHIEF_CH33 from '@/components/tocatchathief_ch33'
 import TOCATCHATHIEF_CH34 from '@/components/tocatchathief_ch34'
 import TOCATCHATHIEF_CH35 from '@/components/tocatchathief_ch35'
 import TOCATCHATHIEF_CH36 from '@/components/tocatchathief_ch36'
 import TOCATCHATHIEF_CH37 from '@/components/tocatchathief_ch37'
 import TOCATCHATHIEF_CH38 from '@/components/tocatchathief_ch38'
 import TOCATCHATHIEF_EPI from '@/components/tocatchathief_epi'
 import TOCATCHATHIEF_AUT from '@/components/tocatchathief_aut'
 import TOCATCHATHIEF_COP from '@/components/tocatchathief_cop'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/tocatchathief_cov",
 			"name" : "tocatchathief_cov",
 			"component" : TOCATCHATHIEF_COV
 		},
 		{
 			"path" : "/tocatchathief_rew",
 			"name" : "tocatchathief_rew",
 			"component" : TOCATCHATHIEF_REW
 		},
 		{
 			"path" : "/tocatchathief_adp",
 			"name" : "tocatchathief_adp",
 			"component" : TOCATCHATHIEF_ADP
 		},
 		{
 			"path" : "/tocatchathief_tit",
 			"name" : "tocatchathief_tit",
 			"component" : TOCATCHATHIEF_TIT
 		},
 		{
 			"path" : "/tocatchathief_frm01",
 			"name" : "tocatchathief_frm01",
 			"component" : TOCATCHATHIEF_FRM01
 		},
 		{
 			"path" : "/tocatchathief_ack",
 			"name" : "tocatchathief_ack",
 			"component" : TOCATCHATHIEF_ACK
 		},
 		{
 			"path" : "/tocatchathief_htl",
 			"name" : "tocatchathief_htl",
 			"component" : TOCATCHATHIEF_HTL
 		},
 		{
 			"path" : "/tocatchathief_contents",
 			"name" : "tocatchathief_contents",
 			"component" : TOCATCHATHIEF_CONTENTS
 		},
 		{
 			"path" : "/tocatchathief_pro",
 			"name" : "tocatchathief_pro",
 			"component" : TOCATCHATHIEF_PRO
 		},
 		{
 			"path" : "/tocatchathief_ch01",
 			"name" : "tocatchathief_ch01",
 			"component" : TOCATCHATHIEF_CH01
 		},
 		{
 			"path" : "/tocatchathief_ch02",
 			"name" : "tocatchathief_ch02",
 			"component" : TOCATCHATHIEF_CH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js